import { ReactNode } from "react";

export const withRangoContainer = (
	rangoContainer: boolean,
	children: ReactNode
) =>
	rangoContainer ? <div className="rango-container">{children}</div> : children;
